export default __webpack_public_path__ + "static/piaseczynski-8e034cde90274d648e2c520d3fe93790.png";